export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11306.8f217ce6.jpg";